module.exports = __webpack_public_path__ + "assets/img/c954d118eebe38a32564d5e16fefc375.png";